export default __webpack_public_path__ + "static/media/Mobile-03.96d1b524.jpg";